import styled from "styled-components";

interface LeftMenuGroupContainerProps {
  isMenuOpen: boolean;
  isGroupExpanded: boolean;
}

export const LeftMenuGroupContainer = styled.li<LeftMenuGroupContainerProps>`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .group {
    display: grid;
    align-content: center;
    grid-template-columns: 32px auto;
    gap: 16px;

    width: 100%;
    padding: 12px 18px;

    background: ${({ isGroupExpanded, theme }) => isGroupExpanded ? theme.themePrimary : theme.neutralLighter};
    
    cursor: pointer;
    z-index: 1;
    transition: all 0.3s ease;
    
    &:hover {
      background: ${({ theme }) => theme.themePrimary};
    
      span, svg {
        color:  #fff;
      }
    }
    
    span {
      opacity: ${({ isMenuOpen }) => (isMenuOpen ? '1' : '0')};
      visibility: ${({ isMenuOpen }) => (isMenuOpen ? 'visible' : 'hidden')};

      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 32px;

      font: 300 1rem/1.2rem "Roboto", sans-serif;
      white-space: nowrap;
      color: ${({ isGroupExpanded, theme }) => isGroupExpanded ? '#fff' : theme.black};
      
      transition: all 0.3s ease;
    }
    
    > svg {
      color:  ${({ isGroupExpanded, theme }) => isGroupExpanded ? '#fff' : theme.themePrimary};
      height: 32px;
      width: 32px;
    }
  }

  .groupLinks {
    display: flex;
    flex-direction: column;
    width: 100%;

    max-height: ${({ isMenuOpen, isGroupExpanded }) => isGroupExpanded && isMenuOpen ? '1000px' : '0px'};
    opacity: ${({ isMenuOpen, isGroupExpanded }) => isGroupExpanded && isMenuOpen ? '1' : '0'};

    transition: all 0.3s ease;

    li {
      display: flex;
      width: 100%;
      
      button.menuLink {
        border: none;
        background: ${({ theme }) => theme.neutralLighter};

        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px 0 12px 40px;
        gap: 16px;

        font: 300 1rem/1.2rem "Roboto", sans-serif;
        color:  ${({ theme }) => theme.black};
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: ${({ theme }) => theme.themeTertiary};
          &, i {
            color:  ${({ theme }) => '#fff'};
          }
        }

        > i {
          color:  ${({ theme }) => theme.themePrimary};
          display: flex;
          height: 32px;
          width: 32px;
          font-size: 24px;
          align-items: center;
        }
      }
    }
  }
`